export const AUDIO_FX = 'AUDIO_FX';
export const MIDI_FX = 'MIDI_FX';
export const INSTRUMENT = 'INSTRUMENT';
